import {
  DepositAmount,
  DepositLimit,
} from '../../../state/deposit/deposit.types';

const ITEMS_PER_ROW = 3;

export const groupByRows = <T extends unknown[]>(items: T) =>
  items.reduce((accumulator: T[], item, index) => {
    if (index % ITEMS_PER_ROW === 0) {
      accumulator.push([] as never);
    }

    accumulator[accumulator.length - 1].push(item);

    return accumulator;
  }, []);

export const getAmountLimit = (limits: DepositLimit[]) => {
  let currentLimit: DepositLimit | undefined;

  limits.forEach((limit) => {
    if (!limit.amount) {
      return;
    }

    const diff = limit.amount - limit.accumulatedAmount;
    const diffActive =
      (currentLimit?.amount ?? 0) - (currentLimit?.accumulatedAmount ?? 0);

    if (diff < diffActive || currentLimit === undefined) {
      currentLimit = limit;
    }
  });

  return currentLimit;
};

export const getLimitRemainingAmount = (limit?: DepositLimit) =>
  limit && limit.amount && limit.amount - limit.accumulatedAmount;

export const isAmountLimitReached = (limit?: DepositLimit) => {
  const limitRemaining = getLimitRemainingAmount(limit);

  return limitRemaining !== undefined && limitRemaining <= 0;
};

export const checkIfOtherSelected = (
  availableAmounts: DepositAmount[],
  selectedAmount?: number,
) =>
  selectedAmount !== undefined &&
  !availableAmounts.some(({ amount }) => amount === selectedAmount);
